export default "__VITE_ASSET__BWlAZKOi__"